export default __webpack_public_path__ + "static/media/playstore-s3.eab75887.webp";